import {
  ArrayField,
  ChipField,
  Datagrid,
  ReferenceField,
  SingleFieldList,
  TextField,
  useGetMany,
  useRecordContext
} from "react-admin";
import { makeStyles } from '@mui/styles';
import { groupBy } from "lodash";

export enum HoseIdentifierType {
  code = 'code',
  hoseNumber = 'hoseNumber',
};

const useStyles = makeStyles({
  fileNameColumn: {
    width: '300px',
  },
  headerCellStyle: {
    '& .RaDatagrid-headerCell': { backgroundColor: '#E5E5E5' }
  }
});

const HoseField = ({ reference, source, name }: { reference: string, source: string, name: string }) => {
  const classes = useStyles();

  const record = useRecordContext();
  if (!record) return null;

  const { data, isLoading } = useGetMany(reference,
    { ids: record[source] }
  );

  if (isLoading || !data?.length) return null;

  const formatData = data.map((item, i) => {
    const hoseName = name === HoseIdentifierType.hoseNumber ? 'fuel.name' : 'fuelId';
    const grouped = groupBy(item.hoses, hoseName);

    const fuels = Object.entries(grouped).map(([groupKey, hoses]) => ({
      fuelId: groupKey,
      fuelName: groupKey,
      hoses: hoses.map((h) => ({ ...h, [name]: h[name] })),
    }));

    return {
      ...item,
      id: `${item.id}-${name}`,
      fuels
    };
  });

  const FuelsPanel = () => {
    const record = useRecordContext();

    return (
      <Datagrid data={record.fuels} bulkActionButtons={false}>
        {
          name === HoseIdentifierType.hoseNumber ?
            <TextField source="fuelName" label="Combustível" />
            :
            <ReferenceField
              reference="fuels"
              source="fuelId"
              label="Combustível"
              sortable={false}
              link="show"
            >
              <TextField source="name" />
            </ReferenceField>
        }
        <ArrayField source="hoses" label="Bicos" sortable={false}>
          <SingleFieldList linkType={false}>
            <ChipField source={name} />
          </SingleFieldList>
        </ArrayField>
      </Datagrid>
    );
  }

  return (
    <Datagrid
      data={formatData}
      bulkActionButtons={false}
      className={classes.headerCellStyle}
      expand={<FuelsPanel />}
    >
      <ReferenceField
        reference="stations"
        source="stationId"
        label="Posto"
        sortable={false}
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
  );
}

export default HoseField;
